import * as React from 'react';

// #region Component Props

interface IProps {
    icon        : string;
    title       : string;
    description : string;
    onclick     : any;
    activeCheck : boolean;
}

// #endregion

export const PresetRoleBox = (props : IProps) => {

    const { icon, title, description, onclick, activeCheck } = props;

    return <div className="quick-role">
                <i className={"primary la " + icon}/>
                <div>
                    <h3>{title}</h3>
                    <p>{description}</p>
                    <button onClick={onclick} className={ activeCheck ? 'active' : ''}>
                        <i className="la la-check-circle"/>
                    </button>
                </div>
            </div>;
};
